import { render, staticRenderFns } from "./CertificateTypeTemplate.vue?vue&type=template&id=7073e911&scoped=true"
import script from "./CertificateTypeTemplate.vue?vue&type=script&lang=ts"
export * from "./CertificateTypeTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7073e911",
  null
  
)

export default component.exports